import { getRamsRecords } from '../../../HttpRequests/ramsRecords'
import { loadRamsRecords } from '../State/project'
import { setFetching } from '../State/fetching'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { id } = getProps().match.params

  const params = {
    'filter[project_id]': id,
    include: 'clientContact',
  }

  dispatch(setFetching(true))

  try {

    const response = await getRamsRecords({ id, params })

    dispatch(loadRamsRecords(response.data.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(setFetching(false))

  }

}
